export default __webpack_public_path__ + "static/media/antech.342a3b82.svg";